<template>
  <div
    class="row col-12 q-gutter-sm text-brand-5 text-weight-bold items-center"
  >
    <div class="row col">
      <div v-if="tipo" class="col-md col-xs">
        <div class="texto-titulo-input">Tipo</div>
        <q-select
          :disable="!editar"
          v-model="cabecalho.tipo"
          :options="options"
          behavior="menu"
          dense
          outlined
          class="input"
        />
      </div>
      <div class="col-md col-xs q-ml-sm">
        <div class="texto-titulo-input">Numero</div>
        <q-input
          :disable="!editar || documentoNumeroDisable"
          v-model="cabecalho.numeroNota"
          dense
          outlined
          class="input"
        />
      </div>
      <div v-if="documentoSerie" class="col-md col-xs q-ml-sm">
        <div class="texto-titulo-input">Série</div>
        <q-input
          class="input"
          :disable="!editar"
          v-model="cabecalho.serie"
          dense
          outlined
        />
      </div>
    </div>
    <div class="row col-md col-xs-12 items-center">
      <div class="row col-md col-sm col-xs">
        <div class="texto-titulo-input">Data de Emissão</div>
        <q-input
          dense
          outlined
          class="input col-12"
          placeholder="DD/MM/AAAA"
          mask="##/##/####"
          v-model="cabecalho.dataEmissao"
          :disable="!editar"
        >
          <template v-slot:append>
            <q-icon name="event" class="cursor-pointer">
              <q-popup-proxy
                cover
                transition-show="scale"
                transition-hide="scale"
              >
                <q-date
                  :locale="myLocale"
                  v-model="cabecalho.dataEmissao"
                  :options="validacaodata"
                  mask="DD/MM/YYYY"
                >
                  <div class="row items-center justify-end">
                    <q-btn v-close-popup label="Fechar" color="primary" flat />
                  </div>
                </q-date>
              </q-popup-proxy>
            </q-icon>
          </template>
        </q-input>
      </div>
      <div class="col-md col-xs q-ml-sm">
        <div class="texto-titulo-input">Fornecedor</div>
        <SelecaoFornecedor
          :unidadeId="$store.state.org.unidadeData.id"
          :model="cabecalho.fornecedor"
          :desabilitado="editar"
          @enviarFornecedor="receberFornecedor"
        />
      </div>
      <div class="q-ml-sm q-mr-sm">
        <div v-if="!editar">
          <p></p>
          <q-btn
            class="q-mt-xs btn"
            icon="edit"
            color="primary"
            @click="editar = true"
          />
        </div>
        <div v-else>
          <p></p>
          <q-btn
            class="q-mt-xs btn"
            icon="done"
            color="positive"
            @click="salvarCabecalho()"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { onMounted, ref, watch } from "vue";
import { useStore } from "vuex";

import SelecaoFornecedor from "./SelecaoFornecedor.vue";

export default {
  components: {
    SelecaoFornecedor,
  },
  props: [
    "tipoCabecalho",
    "validarDado",
    "documentoNumero",
    "documentoSerie",
    "documentoNumeroDisable",
    "tipo",
  ],
  emits: ["iniciarCriacao"],
  setup(props) {
    const store = useStore();

    const cabecalho = ref({
      tipo: "",
      numeroNota: props.documentoNumero,
      serie: "",
      dataEmissao: "",
      fornecedor: "",
    });
    const options = ref([
      { label: "Nota Fiscal", value: "nf" },
      { label: "Romaneio", value: "romaneio" },
    ]);
    let editar = ref(false);
    let dataValida = new Date();

    const salvarCabecalho = () => {
      if (
        cabecalho.value.numeroNota === "" &&
        cabecalho.value.serie === "" &&
        cabecalho.value.tipo === "" &&
        cabecalho.value.dataEmissao === "" &&
        cabecalho.value.fornecedor == ""
      ) {
        store.commit("ferramentaria/SALVAR_CABECALHO", null);
        return;
      }
      store.commit("ferramentaria/SALVAR_CABECALHO", cabecalho.value);
      editar.value = false;
    };

    const verificarCabecalho = () => {
      editar.value = true;
      store.commit("ferramentaria/SALVAR_CABECALHO", null);
      cabecalho.value = {
        tipo: "",
        numeroNota: props.documentoNumero,
        serie: "",
        dataEmissao: "",
        fornecedor: "",
      };
    };

    const receberFornecedor = (value) => {
      cabecalho.value.fornecedor = value;
    };

    watch(
      () => props.documentoNumero,
      () => {
        cabecalho.value.numeroNota = props.documentoNumero;
      }
    );

    onMounted(() => {
      verificarCabecalho();
    });

    return {
      cabecalho,
      salvarCabecalho,
      verificarCabecalho,
      options,
      receberFornecedor,
      validacaodata(date) {
        let hoje = new Date();

        let ontem = new Date(hoje.getTime());
        ontem.setDate(hoje.getDate());

        let dd = ontem.getDate();
        let mm = ontem.getMonth() + 1;
        let yyyy = ontem.getFullYear();

        if (dd < 10) {
          dd = "0" + dd;
        }

        if (mm < 10) {
          mm = "0" + mm;
        }

        let data_valida = yyyy + "/" + mm + "/" + dd;
        dataValida = data_valida;

        return date <= data_valida;
      },
      editar,
      dataValida,
      myLocale: {
        days: "Domingo_Segunda_Terça_Quarta_Quinta_Sexta_Sábado".split("_"),
        daysShort: "Dom_Seg_Ter_Quar_Quin_Sex_Sáb".split("_"),
        months:
          "Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro".split(
            "_"
          ),
        monthsShort: "Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez".split(
          "_"
        ),
        firstDayOfWeek: 1,
      },
    };
  },
};
</script>

<style scoped>
@media (max-width: 600px) {
  .texto-titulo-input {
    font-size: 12px;
  }
  .input {
    font-size: 12px;
  }
  .btn {
    font-size: 12px;
  }
}
</style>
